import { FilterIdentifier, getSavedViewIdentifier } from 'models/saved_view'
import { toast } from 'react-toastify'
import useApiService from 'services/api'
import { invalidateSavedFilterQueries } from 'services/saved_filters'
import { extractSavedFilterPayload, FilterStore } from '../FilterStore'
import { SavedFilterFormData, SavedFilterModal } from './SavedFilterModal'

interface CreateSavedFilterModalProps {
  show: boolean
  handleClose: () => void
  identifier: FilterIdentifier
  filterStore: FilterStore
  onFilterCreated?: () => void
}

export function CreateSavedFilterModal({
  show,
  handleClose,
  identifier,
  filterStore,
  onFilterCreated,
}: CreateSavedFilterModalProps) {
  const api = useApiService()

  const filterState = filterStore()

  const handleSubmitSuccess = () => {
    toast.success('Filter saved!')
    onFilterCreated?.()
  }

  // Persist + invalidate against the base table identifier so a filter saved
  // on one campaign is reusable across every campaign of the same type
  // (FIR-7494). Non-campaign modifiers are left intact by the helper.
  const savedViewIdentifier = getSavedViewIdentifier(identifier)

  const createFilter = async (values: SavedFilterFormData) => {
    const filters = extractSavedFilterPayload(filterState)

    await api.saveFilters({
      identifier: savedViewIdentifier,
      name: values.name,
      shared: values.shared,
      payload: filters,
    })

    await invalidateSavedFilterQueries(savedViewIdentifier)
  }

  return (
    <SavedFilterModal
      show={show}
      handleClose={handleClose}
      onSubmitSuccess={handleSubmitSuccess}
      confirmButtonText="Save"
      submitApiAction={createFilter}
      title="Save Filter"
      description="Create a new filter to save this view, which includes both filters and any search terms."
    />
  )
}
